import PageLayoutView from 'src/components/layout/PageLayout/view'
import useCalcHeightVh from 'src/hooks/useCalcHeightVh.hook'
import useSessionCheck from 'src/hooks/useSessionCheck.hook'
import useNavigationTypeReplace from 'src/hooks/useNavigationTypeReplace.hook'
import { useToastCallFromApp } from 'src/hooks/useToastCallFromApp'
import useSystemNotice from 'src/hooks/useSystemNotice.hook'
import { useDisplayLight } from 'src/hooks/useDisplayLight'
import { useAppInfo } from 'src/hooks/useAppInfo'
import usePartnerEntry from 'src/hooks/usePartnerEntry.hook'

const PageLayout = () => {
  useSessionCheck()
  useNavigationTypeReplace()
  useCalcHeightVh()
  useToastCallFromApp()
  useSystemNotice()
  useDisplayLight()
  useAppInfo()
  usePartnerEntry()

  return <PageLayoutView />
}
export default PageLayout
